import React from "react";
import AuthorCSS from "../../../style/helperCSS/Author.module.css";

const Author = (props) => {
  return (
    <div className={`mt-25 ${AuthorCSS.all_authors}`}>
      {props.authors.map((author, index) => (
        <div className={`${AuthorCSS.author}`} key={index}>
          <img src={author.img} alt="icon" />
          <a href={author.link} target="_blank">
            <p>{author.author_name}</p>
          </a>
        </div>
      ))}
    </div>
  );
};

export default Author;
